var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Link from "@cloudscape-design/components/link";
import Box from "@cloudscape-design/components/box";
var PATH_SEPARATOR = "/";
var ReadOnlyBreadcrumb = function (props) {
    return (_jsx("li", __assign({ className: "breadcrumb_item" }, { children: _jsx(Box, __assign({ variant: "awsui-key-label", color: "text-status-inactive" }, { children: _jsx("span", __assign({ "aria-current": "page" }, { children: props.label })) })) })));
};
var ClickableBreadcrumb = function (props) {
    return (_jsx("li", __assign({ className: "breadcrumb_item" }, { children: _jsxs(SpaceBetween, __assign({ direction: "horizontal", size: "xs" }, { children: [_jsx(Link, __assign({ onFollow: function () {
                        props.onClick(props.fullPath);
                    } }, { children: props.label })), _jsx(PathSeparator, {})] })) })));
};
export var BreadCrumbs = function (_a) {
    var _b = _a.pathSeparator, pathSeparator = _b === void 0 ? PATH_SEPARATOR : _b, _c = _a.rootPath, rootPath = _c === void 0 ? PATH_SEPARATOR : _c, props = __rest(_a, ["pathSeparator", "rootPath"]);
    var breadcrumbs = convertPathToBreadCrumbs(props.path, pathSeparator);
    var currentLocationBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    return (_jsx("nav", __assign({ "aria-label": props.ariaLabel }, { children: _jsxs("ol", __assign({ className: "breadcrumb" }, { children: [breadcrumbs
                    .slice(0, -1)
                    .filter(function (_a) {
                    var fullPath = _a.fullPath;
                    // Root directory - include
                    if (fullPath === rootPath) {
                        return true;
                    }
                    // Parent of root directory - skip!
                    if (rootPath.startsWith(fullPath)) {
                        return false;
                    }
                    // Child of root directory - include
                    return true;
                })
                    .map(function (_a) {
                    var text = _a.text, fullPath = _a.fullPath;
                    return (_jsx(ClickableBreadcrumb, { label: text, fullPath: fullPath, onClick: props.onClick }, fullPath));
                }), _jsx(ReadOnlyBreadcrumb, { label: currentLocationBreadcrumb.text, fullPath: currentLocationBreadcrumb.fullPath })] })) })));
};
var PathSeparator = function () {
    return (_jsx("svg", __assign({ className: "path_separator", viewBox: "0 0 9 14", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.78445 0L0.499991 1.28446L6.21481 7L0.499991 12.7155L1.78445 14L8.78445 7L1.78445 0Z", fill: "#5F6B7A" }) })));
};
var convertPathToBreadCrumbs = function (path, pathSeparator) {
    var _a;
    var pathChunks = (_a = path === null || path === void 0 ? void 0 : path.split(pathSeparator)) !== null && _a !== void 0 ? _a : [];
    var pathBreadCrumbs = pathChunks.filter(Boolean).map(function (p, i, inputArray) {
        var href = "/".concat(inputArray.slice(0, i + 1).join(pathSeparator));
        return { text: p, fullPath: href };
    });
    pathBreadCrumbs.unshift({
        text: pathSeparator,
        fullPath: pathSeparator,
    });
    return pathBreadCrumbs;
};
